<template>
  <generic-modal :title="$t('loan type')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("name") }} <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :class="{ 'is-danger': !meta.name }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">&nbsp;</label>
            <div class="control">
              <label class="checkbox">
                <input type="checkbox" v-model="meta.is_active" />
                {{ $t("is active") }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("description") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.description"
            rows="2"
          ></textarea>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("min amount") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.min_amount"
                step="0.01"
                :class="{ 'is-danger': !meta.min_amount }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("max amount") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.max_amount"
                step="0.01"
                :class="{ 'is-danger': !meta.max_amount }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("min quotas") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.min_quotas"
                step="1"
                :class="{ 'is-danger': !meta.min_quotas }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("max quotas") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.max_quotas"
                step="1"
                :class="{ 'is-danger': !meta.max_quotas }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("payment frequency") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="select is-fullwidth">
              <select
                v-model="meta.payment_frequency"
                :class="{ 'is-danger': !meta.payment_frequency }"
              >
                <option value="" disabled>{{ $t("select an option") }}</option>
                <option value="weekly">{{ $t("weekly") }}</option>
                <option value="biweekly">{{ $t("biweekly") }}</option>
                <option value="monthly">{{ $t("monthly") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("grace period days") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.grace_period_days"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("late fee percentage") }}</label>
            <div class="control">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input
                    type="number"
                    class="input"
                    v-model="meta.late_fee_percentage"
                    step="0.01"
                  />
                </div>
                <div class="control">
                  <span class="button is-static">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("interest rate") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input
                    type="number"
                    class="input"
                    v-model="meta.interest_rate"
                    step="0.01"
                    :class="{ 'is-danger': !meta.interest_rate }"
                  />
                </div>
                <div class="control">
                  <span class="button is-static">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>

    <div class="notification is-danger" v-if="error" v-html="error"></div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { generate_error_message_text, del, post, put, get } from "@/utils";

export default {
  name: "LoanTypeModal",
  components: { GenericModal },
  data() {
    let v = this;
    return {
      meta: {
        grace_period_days: 0,
        late_fee_percentage: 0,
        is_active: true,
      },
      error: "",
      loan_type_uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name;
      // !this.meta.min_amount ||
      // !this.meta.max_amount ||
      // !this.meta.interest_rate
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.loan_type_uuid = uuid;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_loan_type(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      if (v.is_form_invalid) return;

      let data = { ...v.meta };

      if (v.loan_type_uuid) {
        data.uuid = v.loan_type_uuid;
        post("/loan/loan-type", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/loan/loan-type", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    get_loan_type(uuid) {
      let v = this;
      get("/loan/loan-type", { uuid: uuid })
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        grace_period_days: 0,
        late_fee_percentage: 0,
        is_active: true,
      };
      v.error = "";
      v.loan_type_uuid = "";
    },
  },
  watch: {},
};
</script>
